/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo, useState } from 'react'
import { compose } from 'redux'
import config from 'config'
import PropTypes from 'prop-types'
import scriptLoader from 'react-async-script-loader'
import { Collapse } from 'react-collapse'

import { collapsibleClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'

import RateTableFooterDisclosure from 'components/RateTableFooterDisclosure/Disclosure'
import LendersList from 'components/lenders-list'
import { getCtaUrl } from 'personal-loan/rate-table/utils'
import { loadLendersRates } from 'common/utils/rates'
import FooterLinks from 'components/footer-links'

import styles from './styles.module.scss'
import DefaultHeader from '../components/default-header'
import PoweredBy from '../../../components/powered-by'

const ShortenedRateTableApp = (props) => {
  const {
    isScriptLoaded,
    trackSnowplowEvent,
    theme,
    embeddedWidgetQueryParams,
    availableLenders = [],
    showRateTableAsFirstPrequalStep = false,
    otherOptions,
  } = props

  const [isOpen, setIsOpen] = useState(false)
  const [isDisclosureOpen, setIsDisclosureOpen] = useState(false)

  const toggleLenderList = () => {
    setIsOpen((prevOpen) => !prevOpen)

    trackSnowplowEvent(collapsibleClick, {
      text: isOpen ? 'Hide additional lenders' : 'Show additional lenders',
      action: isOpen ? 'collapse' : 'expand',
    })
  }

  const lenders = useMemo(() => {
    if (isScriptLoaded) {
      return loadLendersRates({
        availableLenders,
        filters: { vertical: 'personal' },
      })
    }

    return []
  }, [isScriptLoaded, availableLenders])
  const totalLender = lenders.length
  const iconClass = isOpen ? 'icon-chevron-up' : 'icon-chevron-down'

  const ctaUrl = getCtaUrl({ embeddedWidgetQueryParams, showRateTableAsFirstPrequalStep })

  return (
    <div className={styles.shortenedRateTableRoot}>
      <div className={styles.containerPadding}>
        <PoweredBy className={`mb-8 ${styles.displayDesktop}`} />
        <DefaultHeader {...props} setIsDisclosureOpen={setIsDisclosureOpen} />
      </div>
      <hr />
      <div className={styles.containerPadding}>
        <LendersList
          lenders={lenders.slice(0, 3)}
          ctaUrl={ctaUrl}
          openUrlInNewTab={!showRateTableAsFirstPrequalStep}
          theme={theme}
          name="personalLoan"
          otherOptions={otherOptions}
        />
        <div>
          <Collapse isOpened={isOpen}>
            <LendersList
              lenders={lenders.slice(3)}
              ctaUrl={ctaUrl}
              openUrlInNewTab={!showRateTableAsFirstPrequalStep}
              theme={theme}
              noBorder
              name="personalLoan"
              otherOptions={otherOptions}
            />
          </Collapse>
          <div
            data-testid="toggleLenderList"
            className={styles.viewMoreSection}
            onClick={toggleLenderList}
          >
            <p className={`${styles.viewMore} secondary500 semiBold`}>
              {isOpen ? 'Hide additional lenders' : `View ${totalLender - 3} more lenders`}
              <span className={`cred-icon ${iconClass}`} />
            </p>
          </div>
        </div>
      </div>
      <FooterLinks containerClassName={styles.footerLinks} small />
      <PoweredBy className={`${styles.displayMobile}`} stylesClassName="disclaimer" />
      <RateTableFooterDisclosure
        slug="personal.landing.footer"
        isOpen={isDisclosureOpen}
        toggleDisclosure={() => setIsDisclosureOpen((prevOpen) => !prevOpen)}
      />
    </div>
  )
}

ShortenedRateTableApp.propTypes = {
  isScriptLoaded: PropTypes.bool,
  embeddedWidgetQueryParams: PropTypes.string.isRequired,
  trackSnowplowEvent: PropTypes.func,
  theme: PropTypes.string,
  showRateTableAsFirstPrequalStep: PropTypes.bool,
  availableLenders: PropTypes.instanceOf(Array),
  otherOptions: PropTypes.instanceOf(Array),
}

export { ShortenedRateTableApp }

export default compose(
  scriptLoader(config.ratesLibraryUrl),
  withSnowplowContexts,
)(ShortenedRateTableApp)
